<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-hourglass-half">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import DLZFilter from "../../filterImplementations/DLZFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<DLZFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const text = computed(() => {
  const hours = props.filter.definitionOfDLZInHours;
  if (hours % 24 === 0) {
    return `${t("components.eventAction.filter.ui.DLZ.textShort")}: ${hours / 24} ${t(
      "components.eventAction.filter.ui.RecentlyChanged.days",
      { count: Math.round((hours / 24) * 1000) / 1000 },
    )}`;
  }
  return `${t("components.eventAction.filter.ui.DLZ.textShort")}: ${
    Math.round(hours * 1000) / 1000
  } ${t("components.eventAction.filter.ui.RecentlyChanged.hours", {
    count: Math.round(hours * 1000) / 1000,
  })}`;
});
</script>

<style lang="scss" scoped></style>
